import { Rda } from './rda.model';
import { TipoEmpresaComposicaoRda } from './tipo-empresa-composicao-rda.model';
import { PessoaJuridicaView } from './pessoa-juridica-view.model';

export class ComposicaoRda {

  id: number;
  rda: Rda;
  idPessoaJuridicaRDA: number;
  idPessoaJuridicaUnico: number;
  tipoEmpresa: TipoEmpresaComposicaoRda;
  pessoaJuridicaView: PessoaJuridicaView
  gerouTrimestral: boolean;

  constructor(init?: Partial<ComposicaoRda>) {
    Object.assign(this, init);
  }

}
